import { TranslationMap } from '@trimble-gcs/i18n-types';

export function recycleBinTranslations() {
  return {
    title: {
      text: $localize`:@@config.recycleBin.title:Project Recycle Bin`,
      desc: 'Title for the recycle bin page.',
    },
    loadError: {
      text: $localize`:@@config.recycleBin.loadError:Failed to load Recycle Bin Data`,
      desc: 'Error message shown when the recycle bin data fails to load.',
    },
    reload: {
      tooltip: {
        text: $localize`:@@config.recycleBin.reload.tooltip:Reload Recycle Bin Data`,
        desc:
          "Tooltip for the 'Reload' button. " +
          'The button reloads the data in the project recycle bin from the server and refreshes the current view.',
      },
    },
    autoDelete: {
      other: {
        text: $localize`:@@config.recycleBin.autoDelete:Items older than {count} days will automatically be deleted.`,
        desc: 'Message informing user that items in the recycle bin for {count} days will automatically be deleted.',
      },
    },
    confirmDeleteDialog: {
      title: {
        text: $localize`:@@config.recycleBin.confirmDeleteDialog.title:Delete {Reality Capture} Data`,
        desc:
          'Title of the multiple item delete confirmation dialog. ' +
          "The term 'Reality Capture' is the product name and is not translated.",
      },
      message: {
        '=1': {
          text: $localize`:@@config.recycleBin.confirmDeleteDialog.message.one:Are you sure you want to delete this item?`,
          desc: 'Confirmation message shown when deleting a single item.',
        },
        other: {
          text: $localize`:@@config.recycleBin.confirmDeleteDialog.message.other:Are you sure you want to delete these {count} items?`,
          desc: 'Confirmation message shown when deleting multiple items. The {count} value will always be larger than one.',
        },
      },
      delete: {
        text: $localize`:@@config.recycleBin.confirmDeleteDialog.delete:Delete`,
        desc: 'Button text to confirm delete.',
      },
    },
    deleteErrorDialog: {
      title: {
        text: $localize`:@@config.recycleBin.deleteErrorDialog.title:Delete Error`,
        desc: 'Title of the error dialog when there was a failure deleting items.',
      },
      message: {
        '=1': {
          text: $localize`:@@config.recycleBin.deleteErrorDialog.message.one:The following scan failed to delete: {names}`,
          desc: 'Error message shown when a single item failed to delete. {names} will contain a single item name.',
        },
        other: {
          text: $localize`:@@config.recycleBin.deleteErrorDialog.message.other:The following scans failed to delete: {names}`,
          desc: 'Error message shown when a multiple items failed to delete. {names} are delimited with a new line.',
        },
      },
      dismiss: {
        text: $localize`:@@config.recycleBin.deleteErrorDialog.dismiss:Dismiss`,
        desc: 'Button text to dismiss the error dialog.',
      },
    },
    restoreErrorDialog: {
      title: {
        text: $localize`:@@config.recycleBin.restoreErrorDialog.title:Restore Error`,
        desc: 'Title of the error dialog when there was a failure restoring items.',
      },
      message: {
        '=1': {
          text: $localize`:@@config.recycleBin.restoreErrorDialog.message.one:The following scan failed to restore: {names}`,
          desc: 'Error message shown when a single item failed to restore. {names} will contain a single item name.',
        },
        other: {
          text: $localize`:@@config.recycleBin.restoreErrorDialog.message.other:The following scans failed to restore: {names}`,
          desc: 'Error message shown when a multiple items failed to restore. {names} are delimited with a new line.',
        },
      },
      dismiss: {
        text: $localize`:@@config.recycleBin.restoreErrorDialog.dismiss:Dismiss`,
        desc: 'Button text to dismiss the error dialog.',
      },
    },
  } satisfies TranslationMap;
}
